import React from "react";
import "./Footer.scss";
import fLogo from "../../assets/footer-logo-2.svg";
import { Link } from "react-router-dom";
import useContactUs from "../../hooks/useContactUs";

const Footer = () => {
  const [contactUs] = useContactUs();

  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="footer_logo_box" data-aos="zoom-in-up">
            <Link to="/">
              <img src={fLogo} alt="" className="footer_logo img-fluid" />
            </Link>
          </div>

          <div className="footer_content">
            <div className="row justify-content-between">
              <div className="col-lg-3">
                <h6>
                  We are ahead to meet the challenge of National advancement in
                  the years to come.
                </h6>

                <div className="social_icon_content">
                  <div className="social_icon">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/OfficialRupaliInsurance/"
                      className="icon"
                      rel="noreferrer"
                    >
                      <i className="fa-brands fa-facebook-f "></i>
                    </a>
                  </div>
                  <div className="social_icon">
                    <a
                      target="_blank"
                      href="https://www.youtube.com/"
                      className="icon"
                      rel="noreferrer"
                    >
                      <i className="fa-brands fa-youtube"></i>{" "}
                    </a>{" "}
                  </div>
                  <div className="social_icon">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/"
                      className="icon"
                      rel="noreferrer"
                    >
                      <i className="fa-brands fa-linkedin"></i>{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer_header">SERVICES</div>
                <ul>
                  <li>
                    <Link to="/property-insurance">Property Insurance</Link>
                  </li>
                  <li>
                    <Link to="/marine-insurance">Marine Insurance</Link>
                  </li>
                  <li>
                    <Link to="/motor-insurance">Motor Insurance</Link>
                  </li>
                  <li>
                    <Link to="/engineering-insurance">
                      Engineering Insurance
                    </Link>
                  </li>
                  <li>
                    <Link to="/miscellaneous-insurance">
                      Miscellaneous Insurance
                    </Link>
                  </li>
                </ul>

                <div className="my-4">
                  <div className="footer_header">CAREER</div>
                  <ul className="mt-2">
                    <li>
                      <Link to="/career">Career Notice</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-2">
                <div className="footer_header">Important Links</div>
                <ul>
                  <li>
                    <a
                      href="http://www.idra.org.bd/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      IDRA
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.sec.gov.bd/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      BSEC
                    </a>
                    {/* <Link to="">BSEC</Link> */}
                  </li>

                  <li>
                    <a
                      href="https://www.dsebd.org/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      DSE
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.cse.com.bd/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      CSE
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-3 contact">
                <div className="footer_header">Contact</div>
                <div className="d-flex">
                  <div className="footer_icon">
                    <i className="fa-regular fa-envelope"></i>
                  </div>{" "}
                  <p>
                    <b>Email:</b> <br /> {contactUs.EmailAdd} <br />
                    rupaliinsurance@gmail.com
                  </p>
                </div>

                <div className="d-flex">
                  <div className="footer_icon">
                    <i className="fa-solid fa-phone"></i>
                  </div>{" "}
                  <p>
                    <b>Phone:</b> +{contactUs.ContactNo},
                  </p>
                </div>

                <div className="d-flex">
                  <div className="footer_icon">
                    <i className="fa-solid fa-fax"></i>
                  </div>{" "}
                  <p>
                    <b>Fax:</b> 02222223385629
                  </p>
                </div>

                <div className="d-flex">
                  <div className="footer_icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>{" "}
                  <p>
                    <b>Address:</b> <br /> {contactUs.Address}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          © 2022 - All Rights Reserved | Developed by{" "}
          <span>
            <Link to="">
              Dragon Information Technology and Communication Limited
            </Link>
          </span>
        </div>
      </div>
    </>
  );
};

export default Footer;
